import React, {Component} from 'react';
import moment from 'moment';
import classNames from 'classnames';

import {
    Card, CardBody, CardTitle,
    Col,
    Container, ListGroup, ListGroupItem, Row,
    Table
} from "reactstrap";

import Loader from '../../../components/display/Loader';
import PolyUtil from "../../../util/PolyUtil";

class ReferenceDisplay extends Component {

    content = () => {
        const {rentalHistory} = this.props;
        const references = rentalHistory.map(function (entry) {
            return entry.reference;
        });

        return (
            <div>
                <Container fluid style={{marginTop: '1em'}}>
                    <h2>Rental References:</h2>
                    {
                        PolyUtil.validArr(references) && references.map(function (ref, i) {
                            return (
                                ref !== null && <ReferenceCard key={i} reference={ref}/>
                            );
                        })
                    }
                </Container>
            </div>
        );
    };

    render() {
        return PolyUtil.propsReady(this.props, ['rentalHistory']) ? this.content() : null;
    }
}

class ReferenceCard extends Component {
    state = {
        address: null,
        isLoading: true
    };

    componentWillMount() {
        let address = PolyUtil.getPropertyAddress(this.props.reference.rental);
        this.setState({address: address, isLoading: false});
    }

    render() {
        const {reference} = this.props;
        const isCurrent = moment(reference.rental.lease_end).isAfter(moment.now());
        const tenancyClass = classNames({
            'text-info': isCurrent
        });
        return (
            <Loader spin isLoading={this.state.isLoading}>
                {
                    this.state.address && (
                        <Card className="pr-card">
                            <CardTitle>
                                <strong>{this.state.address.street_address}</strong><br/>
                                <small>{this.state.address.city + ", " + this.state.address.state}</small>
                            </CardTitle>
                            <CardBody>
                                <Row>
                                    <Col xs={12} sm={6}>
                                        <Table responsive>
                                            <tbody>
                                            <tr>
                                                <th scope="row">Tenancy:</th>
                                                <td>
                                                    <strong>{PolyUtil.formatDate(reference.rental.lease_start)}</strong> to <strong
                                                    className={tenancyClass}>{PolyUtil.formatDate(reference.rental.lease_end)}</strong>
                                                    {
                                                        isCurrent && (
                                                            <div>
                                                                <small className="text-info">This applicant is currently a tenant here, so this reference may be lacking some information.</small>
                                                            </div>
                                                        )
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Reference:</th>
                                                <td>
                                                    <p>{reference.name}</p>
                                                    <p>{reference.email}</p>
                                                    <p>{PolyUtil.formatPhone(reference.phone)}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Comments:</th>
                                                <td>
                                                    <p style={{whiteSpace: "pre-line"}}>{reference.comments || "(no comments provided)"}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Status:</th>
                                                <td>
                                                    {
                                                        reference.confirmed ? (
                                                            <div>
                                                                <span className="text-success"><strong>Confirmed</strong></span> on {PolyUtil.formatDate(reference.created)}
                                                            </div>
                                                        ) : (<span className="text-warning"><strong>Unconfirmed</strong></span>)
                                                    }
                                                </td>
                                            </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        {
                                            reference.confirmed && (
                                                <div style={{maxHeight: '500px', overflowY: 'auto', marginTop: '-1.3em'}}>
                                                    <ListGroup>
                                                        <ListGroupItem className={reference.was_tenant ? "text-success" : "text-danger"}>
                                                            <p className="text-left"> Was a tenant during the reported period:</p>
                                                            <p className="text-right"><strong>{reference.was_tenant ? "Yes" : "No"}</strong></p>
                                                        </ListGroupItem>
                                                        <ListGroupItem className={reference.on_time_rent ? "text-success" : "text-danger"}>
                                                            Paid rent on time: <strong>{reference.on_time_rent ? "Yes" : "No"}</strong>
                                                        </ListGroupItem>
                                                        <ListGroupItem className={!reference.insufficient_funds ? "text-success" : "text-danger"}>
                                                            Tenant gave insufficient-fund checks: <strong>{reference.insufficient_funds ? "Yes" : "No"}</strong>
                                                        </ListGroupItem>
                                                        <ListGroupItem className={!reference.eviction ? "text-success" : "text-danger"}>
                                                            Tenant was given eviction notice(s): <strong>{reference.eviction ? "Yes" : "No"}</strong>
                                                        </ListGroupItem>
                                                        <ListGroupItem className={!reference.criminal_activity ? "text-success" : "text-danger"}>
                                                            Tenant engaged in criminal activity (on property): <strong>{reference.criminal_activity ? "Yes" : "No"}</strong>
                                                        </ListGroupItem>
                                                        <ListGroupItem className={!reference.has_pets ? "text-success" : "text-danger"}>
                                                            Tenant had a pet or service animal: <strong>{reference.has_pets ? "Yes" : "No"}</strong>
                                                        </ListGroupItem>
                                                        <ListGroupItem className={reference.property_condition_acceptable ? "text-success" : "text-danger"}>
                                                            Tenant left property in acceptable condition: <strong>{reference.property_condition_acceptable ? "Yes" : "No"}</strong>
                                                        </ListGroupItem>
                                                        <ListGroupItem className={reference.security_deposit_returned ? "text-success" : "text-danger"}>
                                                            Tenant's security deposit was returned: <strong>{reference.security_deposit_returned ? "Yes" : "No"}</strong>
                                                        </ListGroupItem>
                                                        <ListGroupItem className={reference.would_rent_to_again ? "text-success" : "text-danger"}>
                                                            I would rent to this tenant again: <strong>{reference.would_rent_to_again ? "Yes" : "No"}</strong>
                                                        </ListGroupItem>
                                                    </ListGroup>
                                                </div>
                                            )
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    )
                }
            </Loader>
        );
    }
}

export default ReferenceDisplay;



// WEBPACK FOOTER //
// ./src/containers/owner/applications/ReferenceDisplay.js